// ShippingLabelContent.js
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function ShippingLabelContent({ pkg, formatDate, printRef }) {
  return (
    <div
      ref={printRef}
      style={{
        width: '210mm', // Standard A4 width
        minHeight: '148mm', // Roughly half of A4 height
        margin: '0 auto', // Center the label
        padding: '20mm', // Standard printer margins
        boxSizing: 'border-box',
        background: 'white',
        border: '1px solid #e5e7eb',
        pageBreakAfter: 'avoid', // Prevent extra blank page
        pageBreakInside: 'avoid',
      }}
    >
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        gap: '24px', 
        marginBottom: '32px',
        height: '100%',
      }}>
        <div style={{ flex: '1' }}>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Date: {pkg.createdAt?.seconds ? formatDate(pkg.createdAt.seconds) : 'N/A'}</p>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Tracking Number: {pkg.trackingNumber}</p>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Sender: {pkg.sender || 'N/A'}</p>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Recipient: {pkg.recipient || 'N/A'}</p>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Origin: {pkg.origin || 'N/A'}</p>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Phone Number: </p>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Destination: {pkg.destination || 'N/A'}</p>
          <p style={{ fontSize: '12pt', color: '#4B5563', marginBottom: '8pt' }}>Total: </p>
        </div>

        <div
          style={{
            padding: '16px',
            width: '180px',
            alignSelf: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          }}
        >
          <div
            style={{
              width: '150px',
              height: '150px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#F9FAFB',
              marginBottom: '8px',
              borderRadius: '8px',
            }}
          >
            {pkg.trackingNumber ? (
              <QRCodeSVG
                value={"https://pacepaktt.com/package/" + pkg.id}
                size={130}
                level="H"
              />
            ) : (
              <p style={{ color: '#9CA3AF', fontSize: '12px' }}>No tracking number available</p>
            )}
          </div>
          <div style={{ textAlign: 'center' }}>
            <p style={{ 
              fontSize: '12px', 
              color: '#6B7280', 
              wordBreak: 'break-all', 
              fontFamily: 'monospace',
              margin: '0'
            }}>
              {pkg.trackingNumber}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}